/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Tier__Premium7Inputs */

const en_subscription_tier__premium7 = /** @type {(inputs: Subscription_Tier__Premium7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`💎 Premium`)
};

/**
* | output |
* | --- |
* | "💎 Premium" |
*
* @param {Subscription_Tier__Premium7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const subscription_tier__premium7 = /** @type {((inputs?: Subscription_Tier__Premium7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Tier__Premium7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_subscription_tier__premium7(inputs)
});
export { subscription_tier__premium7 as "subscription_tier__PREMIUM" }